var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47461 6.24695H5.47461H21.4746",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47461 6.24695V4.24695C8.47461 3.71652 8.68532 3.20781 9.0604 2.83273C9.43547 2.45766 9.94418 2.24695 10.4746 2.24695H14.4746C15.005 2.24695 15.5137 2.45766 15.8888 2.83273C16.2639 3.20781 16.4746 3.71652 16.4746 4.24695V6.24695M19.4746 6.24695V20.2469C19.4746 20.7774 19.2639 21.2861 18.8888 21.6612C18.5137 22.0362 18.005 22.2469 17.4746 22.2469H7.47461C6.94418 22.2469 6.43547 22.0362 6.0604 21.6612C5.68532 21.2861 5.47461 20.7774 5.47461 20.2469V6.24695H19.4746Z",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4746 11.2469V17.2469",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4746 11.2469V17.2469",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.474609 0.246948)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.5e93ba6aba74ccd06ff60818fdbb9e7b.svg";
export { ForwardRef as ReactComponent };